import React, { useState, useEffect, useCallback } from "react";
import { useMutation } from "@apollo/react-hooks";

import { GET_DOWNLOAD_INFO } from "./mutations";
import { trackDownload } from "./helpers";

const usePhotoDownload = ({
    downloadType,
    photoId,
    client // optional
}) => {
    const [isStarted, setIsStarted] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [fetchDownloadInfo, { data }] = useMutation(GET_DOWNLOAD_INFO, {
        variables: {
            downloadType,
            photoId
        },
        client
    });

    useEffect(() => {
        if (!!data) {
            // Download the file now that we have the URL
            if (data.downloadPhoto && data.downloadPhoto.downloadUrl) {
                window.location = data.downloadPhoto.downloadUrl;
            }
            setIsComplete(true);
        }
    }, [data]);

    const startDownload = useCallback(() => {
        fetchDownloadInfo();
        setIsStarted(true);
        setIsComplete(false); // reset in case they're downloading again
        trackDownload({ downloadType, photoId });
    }, [downloadType, photoId]);

    return {
        startDownload,
        isStarted,
        isComplete
    };
};

export default usePhotoDownload;
